/* eslint-disable no-undef */
import { createSlice } from '@reduxjs/toolkit';
import { persistExpediente } from '../expedienteSlice';



const initialState = {
    files: {
        new: {
            files: [],
            loadingStatuses: [], // array of status for each file: 'no file' / 'success' / 'uploading' / 'error: ...'
        }
    },
    changes: []
};


// slice object
export const documentoSlice = createSlice({
    name: 'documento',
    initialState,
    reducers: {
        ensureInstanceInitialized: (state, action) => {
            const which = action.payload.which;
            if (!state.files[which]) {
                state.files[which] = {
                    files: [],
                    loadingStatuses: [],
                };
            }
        },
        clearFiles: (state) => {
            state.files = {
                new: {
                    files: [],
                    loadingStatuses: [],
                }
            };
        },
        clearFile: (state, action) => {
            const which = action.payload.which;
            state.files[which] = {
                files: [],
                loadingStatuses: [],
            };
        },
        addFile: (state, action) => {
            const which = action.payload.which;
            state.files[which].files.push(action.payload.file);
            state.files[which].loadingStatuses.push('success');
        },
        removeFile: (state, action) => {
            const which = action.payload.which;
            const index = action.payload.index;
            state.files[which].files.splice(index, 1);
            state.files[which].loadingStatuses.splice(index, 1);
        },
        updateFile: (state, action) => {
            const which = action.payload.which;
            const index = action.payload.index;
            state.files[which].files[index] = action.payload.file;
        },
        updateStatus: (state, action) => {
            const which = action.payload.which;
            const index = action.payload.index;
            if (index !== undefined) {
                state.files[which].loadingStatuses[index] = action.payload.loadingStatus;
            } else {
                // For backward compatibility, update last status
                const lastIndex = state.files[which].loadingStatuses.length - 1;
                if (lastIndex >= 0) {
                    state.files[which].loadingStatuses[lastIndex] = action.payload.loadingStatus;
                }
            }
        },
        addUploadingSlot: (state, action) => {
            const which = action.payload.which;
            state.files[which].files.push('');
            state.files[which].loadingStatuses.push('uploading');
        },
        clearChanges: (state) => {
            state.changes = [];
        },
        addChange: (state, action) => {
            state.changes.push({
                old: action.payload.old,
                new: action.payload.new
            });
        }
    },
    extraReducers: (builder) => {
        builder
            // Clear all uploaded files when expediente is saved successfully
            .addCase(persistExpediente.fulfilled, (state) => {
                // Keep only the 'new' instance, clear all actuacion-specific instances
                state.files = {
                    new: {
                        files: [],
                        loadingStatuses: [],
                    }
                };
            });
    }
});

// selectors
export const selectFiles = (state) => state.documento.files;
export const selectChanges = (state) => state.documento.changes;

// exports
export const {
    ensureInstanceInitialized,
    clearFiles, 
    clearFile,
    addFile,
    removeFile,
    updateFile,
    updateStatus,
    addUploadingSlot,
    clearChanges,
    addChange
} = documentoSlice.actions;
export default documentoSlice.reducer;
